export default {
  allUsers: [],
  user: {},
}
